import { Helmet } from 'react-helmet-async';
// sections
import ContactUsForm from 'src/sections/main-sections/support/ContactUsForm';

// ----------------------------------------------------------------------

export default function SupportPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Contact Support</title>
      </Helmet>

      <ContactUsForm />
    </>
  );
}
